<template>
  <div class="d-flex justify-content-center pb-3 px-2">
    <div class="m-auto container">
      <el-card v-if="!isCallback">
        <img src="@/assets/images/CI/Viacor_Claim_pos_silver_RGB.png" class="m-3 register-logo" />
        <br />
        <br />
        <h5>VIACOR Polymer GmbH</h5>
        <p>{{ $t('register.intro_msg') }}</p>
      </el-card>
      <hr />
      <el-card>
        <div class="d-flex is-justify-space-between mt-3">
          <el-select v-model="formData.gender" class="w-100" :placeholder="$t('general.salution')">
            <el-option :value="0" :label="$t('general.mr')">
              {{ $t('general.mr') }}
            </el-option>
            <el-option :value="1" :label="$t('general.ms')">
              {{ $t('general.ms') }}
            </el-option>
            <el-option :value="2" :label="$t('general.divers')">
              {{ $t('general.divers') }}
            </el-option>
          </el-select>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-input
            v-model="formData.firstname"
            v-validate="validations.first_name"
            class="mr-3"
            :placeholder="$t('general.firstname')"
            name="Vorname"
          ></el-input>
          <el-input
            v-model="formData.lastname"
            v-validate="validations.last_name"
            :placeholder="$t('general.lastname')"
            name="Nachname"
          ></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-input v-model="formData.company" :placeholder="$t('general.company')"></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-input
            v-model="formData.email"
            v-validate="validations.email"
            type="email"
            :placeholder="$t('general.email')"
            name="E-Mail"
          ></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <b-select v-model="formData.phoneCode" class="w-50 mr-3">
            <option v-for="phoneCode in PHONECODES" :key="phoneCode.code" :value="phoneCode.dial_code">
              {{ `${phoneCode.dial_code} ${phoneCode.name}` }}
            </option>
          </b-select>
          <el-input
            v-model="formData.phone"
            v-validate="validations.phone"
            type="phone"
            :placeholder="$t('general.phone')"
            name="Telefon"
          ></el-input>
        </div>
        <div v-if="isCallback" class="d-flex is-justify-space-between mt-3">
          <el-input
            v-model="formData.password"
            type="text"
            class="mr-3"
            :placeholder="$t('general.password') + '(' + $t('general.leave_empty') + ')'"
            name="Passwort"
          ></el-input>
          <el-select
            v-model="formData.roleName"
            v-validate="validations.req"
            :placeholder="$t('general.role')"
            name="Rolle"
          >
            <el-option value="User" label="User" />
            <el-option value="Admin" label="Admin" />
          </el-select>
        </div>
        <el-divider />
        <div class="d-flex is-justify-space-between mt-3">
          <el-input
            v-model="formData.street"
            v-validate="validations.city"
            name="zipCode"
            :placeholder="$t('general.street')"
          ></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-input v-model="formData.streetAdditional" :placeholder="$t('general.street_additional')"></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-input
            v-model="formData.zipCode"
            v-validate="validations.zip_code"
            type="email"
            class="mr-3"
            :placeholder="$t('general.zip_code')"
            name="zipCode"
          ></el-input>
          <el-input
            v-model="formData.city"
            v-validate="validations.city"
            type="phone"
            :placeholder="$t('general.city')"
            name="City"
          ></el-input>
        </div>
        <div class="d-flex is-justify-space-between mt-3">
          <el-select
            v-model="formData.country"
            v-validate="validations.city"
            class="w-50 mr-3"
            name="country"
            filterable
            automatic-dropdown
          >
            <el-option v-for="country in COUNTRIES" :key="country.code" :label="country.name" :value="country.code" />
          </el-select>
          <el-select
            v-model="formData.language"
            v-validate="validations.req"
            :name="$t('general.language')"
            class="w-50"
            :placeholder="$t('placeholder.select_language')"
          >
            <el-option value="en" :label="$t('languages.en')" />
            <el-option value="de" :label="$t('languages.de')" />
          </el-select>
        </div>
      </el-card>
      <el-card v-if="$errors.items.length > 0" class="mt-3">
        <span v-for="msg in $errors.items" :key="msg.key" class="text-danger d-block">{{ msg.msg }}</span>
      </el-card>
      <el-card v-if="showSuccess" class="mt-3 text-success">
        {{ $t('register.success_msg') }}
      </el-card>
      <el-card v-if="error" class="mt-3 text-success">
        {{ error }}
      </el-card>
      <hr />
      <el-button
        v-if="$errors.items.length === 0 && !showSuccess"
        class="w-100"
        :loading="isSubmitting"
        type="primary"
        @click="onSubmit"
      >
        {{ $t('general.submit') }}
      </el-button>
      <br />
    </div>
  </div>
</template>

<script>
import validations from '../../js/validator/validations';
import COUNTRIES from '../../config/countries';
import PHONECODES from '../../config/phone-codes';
import _ from 'lodash';
export default {
  name: 'RegisterView',
  components: {},
  props: {
    isCallback: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.defaultValues = _.cloneDeep(this.formData);
  },
  destroyed() {},
  data() {
    return {
      validations,
      COUNTRIES,
      PHONECODES,
      showSuccess: false,
      isSubmitting: false,
      formData: {
        gender: null,
        firstname: '',
        lastname: '',
        company: '',
        phone: '',
        phoneCode: '+49',
        email: '',
        street: '',
        streetAdditional: '',
        zipCode: '',
        city: '',
        country: 'DE',
        language: null,
        password: '',
        roleName: 'User',
      },
      defaultValues: null,
      error: null,
    };
  },
  computed: {},
  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.isCallback) this.saveRequest();
          else this.$emit('submit', this.formData);
        }
      });
    },
    async saveRequest() {
      this.isSubmitting = true;

      let request = new this.$parse.Object('Request');
      request.set('gender', this.formData.gender);
      request.set('firstname', this.formData.firstname);
      request.set('lastname', this.formData.lastname);
      request.set('company', this.formData.company);
      request.set('email', this.formData.email);
      request.set('phone', this.formData.phoneCode + this.formData.phone);
      request.set('street', this.formData.street);
      request.set('streetAdditional', this.formData.streetAdditional);
      request.set('zipCode', this.formData.zipCode);
      request.set('city', this.formData.city);
      request.set('country', this.formData.country);
      request.set('language', this.formData.language);

      await request.save();
      this.isSubmitting = false;
      this.showSuccess = true;

      this.formData = this.defaultValues;
    },
  },
};
</script>

<style lang="scss" scoped>
.register-background {
  background: url('../../assets/images/Backgrounds/StockSnap_UHBNCUKSFS.jpg');
  background-size: cover;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.register-card {
  max-width: 600px;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(15px);
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-top: 0 !important;
  width: 95%;
}
.register-logo {
  max-width: 300px;
  margin: 0 auto;
}
</style>
